import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { Button, CircularProgress, Container, Dialog, DialogContent, DialogTitle, Grid, IconButton, TextField } from "@material-ui/core";
import { Add, Delete, Edit, View, Visibility } from "@material-ui/icons";
import { FormProvider, useForm } from "react-hook-form";
import RHFInputField from "./RHFInputField";
import useCrudOperation from "./useCrudOperation.hook";
import RHFSelect from "./RHFSelect";
import DataTable from "react-data-table-component";
import styled from "styled-components";
import Size from "@vx/legend/lib/legends/Size";
import AlertComponent from "../Reporting/AlertBox/AlertComponent"
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Chip from '@material-ui/core/Chip';
import CMIOSSwitch from "../CMIOSSwitch";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import axios from 'axios'
const buttontab = new Map([
  ["carmaker_target_class_record_V2", { Add: false, Edit: true }],
  ["fetch-carmaker_scenario_type_record_V2", { Add: false, Edit: true }],
  ["carmaker_situation1_record_V2", { Add: false, Edit: true }],
  ["carmaker_situation2_record_V2", { Add: false, Edit: true }],
  ["fetch-carmaker_assessment_code_record_V2", { Add: true, Edit: true }],
  ["fetch-carmaker_model_record_V2", { Add: true, Edit: true, Delete: true }],
  ["carmaker_simulator_record_v2", { Add: false, Edit: false }],
  ["pr_situation_cat", { Add: true, Edit: true }],
  ["pr_issue_cat", { Add: true, Edit: true }]
]);
export default function CMCriteriaMasters() {
  const classes = useStyles();
  const [value, setValue] = useState(0);



  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Container className={classes.main} boxShadow={1} maxWidth={"xxl"} >
      <div className={classes.root} style={{ height: "100%" }}>
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          className={classes.tabs}
        >

          {tabs.map((tab, index) =>
            <Tab label={tab.label} key={index} {...a11yProps(index)} />
          )}
        </Tabs>
        {
          tabs.map((tab, index) => {
            return <TabPanel value={value} key={index} index={index}>
              <ManageListCrudOperation tableName={tab.tableName} api={tab.api} label={tab.label} />
            </TabPanel>
          })
        }
      </div>
    </Container>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    height: "100%",
    boxShadow: theme.shadows[10]
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  main: {
    height: `calc(100% - ${56}px - ${theme.spacing(5)}px)`,
    marginTop: theme.spacing(4),
  }
}));


const tabs = [
  { label: "Model", tableName: "fetch-carmaker_model_record_V2" },
  { label: "Target Class", tableName: "carmaker_target_class_record_V2" },
  { label: "Scenario Type", tableName: "fetch-carmaker_scenario_type_record_V2" },
  { label: "Situation One", tableName: "carmaker_situation1_record_V2" },
  { label: "Situation Two", tableName: "carmaker_situation2_record_V2" },
  { label: "Assessment Code", tableName: "fetch-carmaker_assessment_code_record_V2" },
  { label: "Simulator", tableName: "carmaker_simulator_record_v2" },
  { label: "Situation Category", tableName: "pr_situation_cat" },
  { label: "Issue Category", tableName: "pr_issue_cat" }
];


// if in future more inputs are required then add similar objects
const commonFields = [
  { name: "key", label: "Key", type: "text", rules: { required: "Key is required" } },
  { name: "value", label: "Value", type: "text", rules: { required: "Value is required" } },
]

const fields = {
  carmaker_target_class_record_V2: commonFields,
  "fetch-carmaker_scenario_type_record_V2": commonFields,
  carmaker_situation1_record_V2: [
    { name: "key", label: "Key", type: "text", rules: { required: "Key is required" } },
    { name: "value.TP/FP", label: "TP/FP", type: "select", defaultValue: "TP", options: [{ value: "TP", label: "TP" }, { value: "FP", label: "FP" }] },
    { name: "value.DAY/NIGHT", label: "DAY/NIGHT", type: "select", defaultValue: "DAY", options: [{ value: "DAY", label: "DAY" }, { value: "EuroNIGHT", label: "EuroNIGHT" }, { value: "J NIGHT", label: "J NIGHT" }, { value: "DarkNIGHT", label: "DarkNIGHT" }, { value: "CiasiNIGHT", label: "CiasiNIGHT" }, { value: "C NIGHT", label: "C NIGHT" }, { value: "Reserved", label: "Reserved" }] },
  ],
  carmaker_situation2_record_V2: [
    { name: "key", label: "Key", type: "text", rules: { required: "Key is required" } },
    { name: "value.AEB/FCW", label: "AEB/FCW", type: "select", defaultValue: "AEB", options: [{ value: "AEB", label: "AEB" }, { value: "FCW", label: "FCW" }, { value: "Reserved", label: "Reserved" }] },
    { name: "value.Obstruction", label: "Obstruction", type: "select", defaultValue: "Reserved", options: [{ value: "\u00d7", label: "\u00d7" }, { value: "\u3007", label: "\u3007" }, { value: "Reserved", label: "Reserved" }] },
  ],
  "fetch-carmaker_assessment_code_record_V2": commonFields,
  "fetch-carmaker_model_record_V2": [...commonFields, { name: "hash_codes", label: "Hash Codes", type: "chip" }, { name: "closed_loop_bench", label: "Closed Loop Bench", type: "switch", defaultValue: "False", options: [{ value: "True", label: "True" }, { value: "False", label: "False" }] },
  { name: "open_loop_bench", label: "Open Loop Bench", type: "switch", defaultValue: "False", options: [{ value: "True", label: "True" }, { value: "False", label: "False" }] },
    , { name: "description", label: "Description", type: "text" }, { name: "documentation", label: "Documentation", type: "file" }],
  carmaker_simulator_record_v2: commonFields,
  pr_situation_cat: [
    { name: "key", label: "Key", type: "text", rules: { required: "Key is required" } },
    { name: "value.TP/FP", label: "TP/FP", type: "select", defaultValue: "TP", options: [{ value: "TP", label: "TP" }, { value: "FP", label: "FP" }] },
    { name: "value.operation_level", label: "Operation Level", type: "text", rules: { required: "Operation level is required" } },
    { name: "description", label: "Description", type: "text" },
  ],
  pr_issue_cat: [
    { name: "key", label: "Key", type: "text", rules: { required: "Key is required" } },
    { name: "value", label: "Value", type: "text", rules: { required: "Value is required" } },
    { name: "description", label: "Description", type: "text" },
  ],
}


const getTableColumns = (tableName) => {
  if (tableName === "fetch-carmaker_model_record_V2") {

    const fetchPresignedUrl = async (s3Key) => {
      try {
        const response = await axios.post(
          "/generate-presigned-url",
          {
            s3_location: s3Key,
          }
        )
        if (response.data) {
          window.open(response.data.presigned_url, "_blank");
        } else {
          console.error("Failed to get document URL:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching document:", error);
      }
    };

    return [{
      name: "Value",
      selector: "value",
      cell: (row) => ViewCell(row.value)
    },
    {
      name: "Closed Loop Bench",
      selector: "closed_loop_bench",
      // cell: (row) => <FormControlLabel
      //   control={<CMIOSSwitch checked={row.value === "true" ? true : false}
      //     name="checkedB" />}
      //   label=""
      // />,
      cell: (row) => ViewCell(row.closed_loop_bench==="true"?"Available":"Not Available"),
      grow: 2
    },
    {
      name: "Open Loop Bench",
      selector: "open_loop_bench",
      // cell: (row) => <FormControlLabel
      //   control={<CMIOSSwitch checked={row.value === "true" ? true : false}
      //     name="checkedB" />}
      //   label=""
      // />,
      cell: (row) => ViewCell(row.open_loop_bench==="true"?"Available":"Not Available"),
      grow: 2
    },
    {
      name: "Hash Codes",
      selector: "hash_codes",
      grow: 6,
      cell: (row) => {
        const hashCodes = row.hash_codes || [];

        const chunkChips = (chips, chunkSize) => {
          const chunks = [];
          for (let i = 0; i < chips.length; i += chunkSize) {
            chunks.push(chips.slice(i, i + chunkSize));
          }
          return chunks;
        };

        const chipRows = chunkChips(hashCodes, 4);

        return (
          <div>
            {chipRows.map((chipRow, rowIndex) => (
              <div
                key={rowIndex}
                style={{
                  display: "flex",
                  gap: "10px",
                  marginBottom: "5px",
                  flexWrap: "wrap",
                }}
              >
                {chipRow.map((chip, chipIndex) => (
                  <Chip
                    key={chipIndex}
                    label={chip}
                    variant="outlined"
                  />
                ))}
              </div>
            ))}
          </div>
        );

      }
    },
    {
      name: "Description",
      selector: "description",
      cell: (row) => ViewCell(row.description ? row.description.substring(0, 20) : ""),
      grow: 3
    },
    {
      name: "Documentation",
      selector: "documentation",
      cell: (row) => {
        return (

          <IconButton onClick={() => fetchPresignedUrl(row.documentation)}>


            <Visibility /></IconButton>
        )
      },
      grow: 2
    }
    ]
  }
  if (tableName === "carmaker_situation1_record_V2") {
    return [{
      name: "TP/FP",
      selector: "value.TP/FP",
      cell: (row) => ViewCell(row.value["TP/FP"]),
    },
    {
      name: "DAY/NIGHT",
      selector: "value.DAY/NIGHT",
      cell: (row) => ViewCell(row.value["DAY/NIGHT"])
    }
    ]
  }
  else if (tableName === "carmaker_situation2_record_V2") {
    return [{
      name: "AEB/FCW",
      selector: "value.AEB/FCW",
      cell: (row) => ViewCell(row.value["AEB/FCW"])
    },
    {
      name: "Obstruction",
      selector: "value.Obstruction",
      cell: (row) => ViewCell(row.value["Obstruction"])
    }
    ]
  }

  else if (tableName === "pr_situation_cat") {
    return [{
      name: "TP/FP",
      selector: "value.TP/FP",
      cell: (row) => ViewCell(row.value["TP/FP"]),
      size: 50
    },
    {
      name: "Operation Level",
      selector: "value.operation_level",
      cell: (row) => ViewCell(row.value["operation_level"]),
      size: 50
    },
    {
      name: "Description",
      selector: "description",
      cell: (row) => ViewCell(row.description),
      size: 400
    }
    ]
  }

  else if (tableName === "pr_issue_cat") {
    return [{
      name: "Value",
      selector: "value",
      cell: (row) => ViewCell(row.value)
    },
    {
      name: "Description",
      selector: "description",
      cell: (row) => ViewCell(row.description),
      grow: 3

    }
    ]
  }

  return [{
    name: "Value",
    selector: "value",
    cell: (row) => ViewCell(row.value)
  }]
}


const customStyles = {
  table: {
    style: {
      border: "solid 1px rgba(0,0,0,.2)",
      borderRadius: "10px",
      width: "100%"
      // minWidth: "900px",
      // maxWidth: "970px"
    },
  },
  rows: {
    style: {
      cursor: "pointer",
      fontSize: 16,
      margin: "10px",
      // minHeight: "unset",
      minHeight:"150px"

    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      backgroundColor: "#b0ff45",
      justifyContent: "center",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
      justifyContent: "center",
      textAlign: "center",

    },
  },
};


const StyledDataTable = styled(DataTable)`
  .rdt_TableBody {
    overflow: auto;
    max-height: calc(100vh - 300px)
  }
`;

const ViewCell = (value) => {
  return <div style={{ flexWrap: "wrap" }}>{value}</div>
}
const ConfirmationDialogue = ({ open, handleClose, data, deleteItem }) => {

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Subscribe</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Do you want to delete <span style={{ fontWeight: "bold" }}>{typeof data.value === "object" ? JSON.stringify(data.value) : data.value}</span>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            deleteItem(data._id);
            handleClose(false);
          }}
          color="red"
          style={{ color: "red" }}
        >
          Delete
        </Button>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
const ManageListCrudOperation = ({ tableName, api, label }) => {
  const [openModal, setOpenModal] = useState({ open: false, data: null })
  const { data, loading, statusQuote, createItem, deleteItem, updateItem } = useCrudOperation(tableName)
  const [deleteDialog, setDialogeDelete] = useState(null)
  const handleModalOpen = (updatableData = null) => {
    console.log("updateTa", updatableData);
    setOpenModal({ open: true, data: updatableData });
  }

  const handleModalClose = () => {
    setOpenModal({ open: false, data: null });
  }

  const columns = useMemo(() => [
    {
      name: "Key",
      selector: "key",
      cell: (row) => ViewCell(row.key),
    },
    ...(getTableColumns(tableName)),
    {
      name: "Actions", selector: "_id", cell: (row) => {
        const value = row._id;

        return (
          <div
            style={{
              display: "flex",
              gap: "5px",
              justifyContent: "center",
            }}
          >
            <IconButton onClick={() => handleModalOpen(row)} style={{ padding: 0 }} disabled={!buttontab.get(tableName)['Edit']}>
              <Edit />
            </IconButton>
            {row.key === "" && row.value === "" ?
              <IconButton onClick={() => {
                setDialogeDelete({ key: row.key, value: row.value, _id: row._id })

              }} style={{ padding: 0, display: "" }} disabled={!buttontab.get(tableName)['Delete']}>
                <Delete />
              </IconButton> : null}

          </div>
        )
      }
    }
  ], [tableName, openModal]);

  return (
    <>
      {deleteDialog && <ConfirmationDialogue open={deleteDialog ? true : false} handleClose={() => setDialogeDelete(null)} data={deleteDialog} deleteItem={deleteItem} />}
      {statusQuote.message &&
        <AlertComponent text={statusQuote.message}
          severity={!statusQuote.isError} />}
      {loading && <Dialog><DialogContent><CircularProgress variant="indeterminate" /></DialogContent></Dialog>}
      <div style={{ display: "flex", width: "100%", justifyContent: "flex-end", marginBottom: "10px" }}>
        <Button onClick={() => handleModalOpen()} startIcon={<Add />} variant="outlined" disabled={!buttontab.get(tableName)['Add']}>Add</Button>
      </div>
      <div>
        <StyledDataTable columns={columns} data={data} customStyles={customStyles} />
      </div>
      {
        openModal.open && <Dialog open={openModal.open} aria-labelledby="AddUpdateMasteryAtbData">
          <DialogTitle>{!openModal.data ? "Add" : "Update"} {label}</DialogTitle>
          <DialogContent>
            <InsertUpdateForm tableName={tableName} handleModalClose={handleModalClose} createItem={createItem} updateItem={(payload) => updateItem(openModal.data._id, payload)} updatableData={openModal.data} />
          </DialogContent>
        </Dialog>
      }
    </>)
}

const FormComponents = ({ fieldsData, chipFields, onAddChip, onDeleteChip, methods, setFile, updatableData }) => {
  console.log("CHIP FIELDS", fieldsData, chipFields)
  return fieldsData.map((field, index) => {
    if (field.type === "text") {
      return <RHFInputField key={field.name} {...field} />
    }
    if (field.type === "select") {
      return <RHFSelect key={field.name} {...field} />
    }
    if (field.type === "chip") {
      return (
        <Grid key={field.name} item xs={12}>
          <Typography variant="subtitle1">{field.label}</Typography>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "10px" }}>
            {(chipFields[field.name] || []).map((chip, idx) => (
              <Chip
                key={idx}
                label={chip}
                // onDelete={() => onDeleteChip(field.name, idx)}
                variant="outlined"
              />
            ))}
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <TextField
              type="text"
              placeholder={`Add ${field.label}`}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onAddChip(field.name, e.target.value);
                  e.target.value = "";
                }
              }}
              style={{ flexGrow: 1, padding: "5px" }}
            />
            <Button
              variant="contained"
              onClick={() => {
                const input = document.querySelector(`input[placeholder="Add ${field.label}"]`);
                onAddChip(field.name, input.value);
                input.value = "";
              }}
            >
              Add
            </Button>
          </div>
        </Grid>
      );
    }

    if (field.type === "switch") {
      return (
        <Grid key={field.name} item xs={12}>
          <FormControlLabel
            control={<CMIOSSwitch
              name={field.name}
              checked={methods.watch(field.name) || "False"}
              onChange={(name, value) => methods.setValue(name, value)}
            />}
            label={field.label}
          />
        </Grid>
      );
    }

    if (field.type === "file") {
      return (
        <Grid key={field.name} item xs={12}>
          <Typography variant="subtitle1">{field.label}</Typography>
          <input
            type="file"
            accept=".pdf,.docx,.txt"
            onChange={(e) => setFile(e.target.files[0])}
          />
          {updatableData && updatableData.documentation && (
            <p>
              <a href={updatableData.documentation} target="_blank" rel="noopener noreferrer">
                View Existing File
              </a>
            </p>
          )}
        </Grid>
      );
    }

    return <React.Fragment key={index} />
  })
}


const InsertUpdateForm = ({ tableName, handleModalClose, createItem, updatableData, updateItem }) => {
  const fieldsData = useMemo(() => fields[tableName] || [], [tableName]);
  const defaultValues = useMemo(() => {
    if (!Array.isArray(fieldsData)) return {};
    return Object.fromEntries(fieldsData.filter(Boolean).map((field) => [field.name, field.defaultValue || ""]));
  }, [fieldsData]);

  const methods = useForm({ defaultValues });
  const [error, setError] = useState(null);
  const [chipFields, setChipFields] = useState({});
  const [file, setFile] = useState(null);


  const handleAddChip = (name, value) => {
    if (value.trim()) {
      setChipFields((prev) => ({
        ...prev,
        [name]: [...(prev[name] || []), value.trim()],
      }));
    }
  };

  const handleDeleteChip = (name, index) => {
    setChipFields((prev) => ({
      ...prev,
      [name]: prev[name].filter((_, i) => i !== index),
    }));
  };

  // useEffect(() => {
  //   const initialChips = fieldsData
  //     .filter((field) => field.type === "chip")
  //     .reduce((acc, field) => ({ ...acc, [field.name]: [] }), {});

  //   console.log("INITIAL VALUES", fieldsData)
  //   setChipFields(initialChips);
  // }, [fieldsData]);


  useEffect(() => {
    console.log(fieldsData)
    const initialChips = fieldsData
      .filter((field) => field.type === "chip")
      .reduce(function (acc, field) {
        acc[field.name] = (updatableData && updatableData[field.name]) || [];
        return acc;
      }, {});

    setChipFields(initialChips);

    const initialValues = fieldsData.reduce((acc, field) => {
      if (field.type !== "chip") {

        acc[field.name] = (updatableData && updatableData[field.name]) ||
          field.defaultValue ||
          "";
      }
      return acc;
    }, {});

    methods.reset(initialValues);
  }, [fieldsData, updatableData, methods]);


  const compareFieldDuplication = (originalData, changeData) => {
    let isChanged = true;

    fieldsData.forEach((obj) => {
      const fieldKey = (obj.name).includes("value") ? "value" : obj.name
      if (JSON.stringify(originalData[fieldKey]) != JSON.stringify(changeData[fieldKey])) isChanged = false;
    });
    return isChanged;
  };
  // const onSubmit = async (data) => {
  //   if (updatableData) {
  //     setError(null);
  //     if (!compareFieldDuplication(updatableData, data)) await updateItem(data);
  //     else throw "No changes found";
  //   } else
  //     await createItem(data);
  // }

  // const onSubmit = async (data) => {
  //   const chipData = Object.entries(chipFields).reduce(
  //     (acc, [name, values]) => ({
  //       ...acc,
  //       [name]: values,
  //     }),
  //     {}
  //   );

  //   const payload = {
  //     ...data,
  //     ...chipData,
  //     ...(updatableData ? { _id: updatableData._id } : {}),
  //   };

  //   if (updatableData) {
  //     await updateItem(payload);
  //   } else {
  //     await createItem(payload);
  //   }
  // };

  // const onSubmit = async (data) => {
  //   console.log("Data inside onSubmit", data)
  //   const chipData = Object.entries(chipFields).reduce(
  //     (acc, [name, values]) => ({ ...acc, [name]: values }),
  //     {}
  //   );

  //   console.log("chipData",chipData)
  //   const formData = new FormData();

  //   Object.entries({ ...data, ...chipData }).forEach(([key, value]) => {
  //     formData.append(key, value);
  //   });


  //   if (file) {
  //     formData.append("documentation", file);
  //   }

  //   if (updatableData) {
  //     await updateItem(formData);
  //   } else {
  //     await createItem(formData);
  //   }
  // };


  const onSubmit = async (data) => {
    console.log("Data inside onSubmit", data);

    const chipData = Object.entries(chipFields).reduce(
      (acc, [name, values]) => ({ ...acc, [name]: values }),
      {}
    );

    console.log("chipData", chipData);

    const formData = new FormData();

    if (updatableData && updatableData._id) {
      console.log("Adding _id to FormData:", updatableData._id);
      formData.append("_id", updatableData._id);
    }

    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, value);
    });

    if ("closed_loop_bench" in data) {
      formData.append("closed_loop_bench", data.closed_loop_bench === "true" ? "true" : "false");
    }
    if ("open_loop_bench" in data) {
      formData.append("open_loop_bench", data.open_loop_bench === "true" ? "true" : "false");
    }

    if (chipData.hash_codes) {
      console.log("FOUND CHIP DATA SO ADDING IT TO FORMDATA", chipData.hash_codes)
      formData.append("hash_codes", JSON.stringify(chipData.hash_codes));

    }

    if (file) {
      formData.append("documentation", file);
    }

    console.log("Final FormData:", formData);
    formData.forEach((value, key) => {
      console.log(key, "=>", value);
    });

    if (updatableData) {
      console.log("Inside updateable data", formData)
      formData.forEach((value, key) => {
        console.log(key, "======================>", value);
      });
      await updateItem(formData);
    } else {
      await createItem(formData);
    }
  };




  return (
    <>
      {<div style={{ marginTop: "5px", marginBottom: "5px" }}><p style={{ color: "red" }}>{error ? error : " "}</p></div>}
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit((data) => {
          onSubmit(data)
            .then(() => {
              handleModalClose();
              methods.reset();
            })
            .catch((error) => {
              setError(error);
            });
        })}>
          <Grid container spacing={2}>
            <FormComponents fieldsData={fieldsData}
              chipFields={chipFields}
              onAddChip={handleAddChip}
              methods={methods}
              setFile={setFile}
              updatableData={updatableData}
            // onDeleteChip={handleDeleteChip}
            />

            <Grid item xs={12}>
              <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end", margin: "10px 0" }}>
                <Button variant="contained" onClick={handleModalClose}>Close</Button>
                <Button variant="contained" type="submit">Save</Button>
              </div>
            </Grid>
          </Grid>
        </form>
      </FormProvider>
    </>
  )
}

// Tab Panel Section
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      style={{ width: "100%" }}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

